export enum DelegeeFileType {
    Validation = 0,
    Invitation = 1,
}